import { getDomElement } from '@shared/dom';
import { useEffect, useState } from 'react';

import { HtmlElementAttribute, TextDirection } from '@/constants';
import { useLocalization } from '@/context/localization';

export const useLanguages = () => {
  const { state } = useLocalization();

  const getLanguageDisplayName = (cultureName: string, inUserLanguage?: boolean) => {
    if (!cultureName) return '';
    const names = new Intl.DisplayNames(inUserLanguage ? state.locale : cultureName, {
      type: 'language',
      style: 'short',
      languageDisplay: 'standard',
    });

    return names.of(cultureName) as string;
  };

  return { getLanguageDisplayName };
};

export const useLanguageDirection = () => {
  const [rtlClass, setRtlClass] = useState(TextDirection.LTR);

  const setLangDirection = (flag: string) => {
    const dir =
      flag.toLowerCase() === (TextDirection.ARABIC as string)
        ? TextDirection.RTL
        : TextDirection.LTR;

    setRtlClass(dir);
    localStorage.setItem('rtlClass', dir);
    getDomElement<HTMLElement>('html')?.setAttribute(HtmlElementAttribute.DIR, dir);
  };

  useEffect(() => {
    const cls = localStorage.getItem('rtlClass') || TextDirection.LTR;
    getDomElement<HTMLElement>('html')?.setAttribute(HtmlElementAttribute.DIR, cls);
  }, []);

  return { rtlClass, setLangDirection };
};
